import { createReactHybridPageRegistry } from '@/cms/reactHybridPageRegistry'
import { createReactPageRegistry } from '@/cms/reactPageRegistry'
import { isSummerPDP } from '@/cms/reactPageRegistryRules'
import { GroupsResponsible } from '@/scopes/account/group-responsible/pages'
import { UserProfile } from '@/scopes/account/user-profile/pages'
import GroupsCheckoutConfirmationStep from '@/scopes/checkout/pages/groups/Confirmation'
import GroupsCheckoutOverviewStep from '@/scopes/checkout/pages/groups/OverviewStep'
import GroupsCheckoutPersonalDetails from '@/scopes/checkout/pages/groups/PersonalDetailsStep'
import GroupsCheckoutStep1 from '@/scopes/checkout/pages/groups/Step1'
import CheckoutPageStep2 from '@/scopes/checkout/pages/Step2'
import featureFlagClient from '@/scopes/common/infrastructure/feature-flags/featureFlagClient'
import { AccommodationPageFullReact as AccommodationPage } from '@/scopes/products/pages'
import QuickSearch from '@/scopes/search/quick-search/components'
import NewSearchPage from '@/scopes/search/search/pages/SearchPage/SearchPage'
import CheckoutPageStep1 from '../scopes/checkout/pages/Step1'

const reactHybridPageRegistry = createReactHybridPageRegistry()
reactHybridPageRegistry.register('HomePage')
reactHybridPageRegistry.register('BrandSummerHomePage')
reactHybridPageRegistry.register('ContentPage')

const reactPageRegistry = createReactPageRegistry()
// TODO Create new ReactAccomodation Page

const FF_ACTIVATE_FULL_REACT_PDP = featureFlagClient.isActive('ACTIVATE_FULL_REACT_PDP')
if (FF_ACTIVATE_FULL_REACT_PDP) {
  reactPageRegistry.registerByRule(isSummerPDP, AccommodationPage)
}

reactPageRegistry.register('d4c58c1a-aadb-468f-84c1-358b21619a59', NewSearchPage)
reactPageRegistry.register('f0150163-c8ba-4f98-8dee-976223022fb4', CheckoutPageStep1)
reactPageRegistry.register('e44033bb-353c-4d1a-8024-99e01cd921e3', CheckoutPageStep2)
reactPageRegistry.register('eebea8a6-bf8d-46ce-b869-90f77c656fab', GroupsCheckoutStep1)
reactPageRegistry.register('903d0998-a38d-465e-bd03-18c28faa7f37', GroupsCheckoutPersonalDetails)
reactPageRegistry.register('35508b07-1720-4eea-9960-38bb1e63f3db', GroupsCheckoutOverviewStep)
reactPageRegistry.register('6e5596a2-3c23-49ad-849e-6acba1e010b4', GroupsCheckoutConfirmationStep)
reactPageRegistry.register('7f45b2c3-1234-56d7-89ab-cdef01234567', GroupsResponsible)
reactPageRegistry.register('7f45b2c3-1234-56d7-89ab-cdef01234999', QuickSearch)
reactPageRegistry.register('7f45b2c3-1234-56d7-89ab-cdef01234568', UserProfile)

export { reactHybridPageRegistry, reactPageRegistry }
